import InsideMenu from './InsideMenu';

export default InsideMenu;
